var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "111px",
    height: "111px",
    viewBox: "0 0 111 111",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_Microphone_1145861") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Utilities/RecordAudio-Start",
    transform: "translate(-665.000000, -416.000000)",
    fill: "#FF4646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(525.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Microphone_1145861",
    transform: "translate(140.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5,0 C86.1518036,0 111,24.8481964 111,55.5 C111,86.1518036 86.1518036,111 55.5,111 C24.8481964,111 0,86.1518036 0,55.5 C0,24.8481964 24.8481964,0 55.5,0 Z M55.5,6.9375 C28.6796718,6.9375 6.9375,28.6796718 6.9375,55.5 C6.9375,82.3203282 28.6796718,104.0625 55.5,104.0625 C82.3203282,104.0625 104.0625,82.3203282 104.0625,55.5 C104.0625,28.6796718 82.3203282,6.9375 55.5,6.9375 Z",
    id: "Oval-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6279408,38.9003046 C46.6279408,34.5370869 50.154355,31 54.5044074,31 C58.8544597,31 62.3808739,34.5370869 62.3808739,38.9003046 L62.3808739,55.9504292 C62.3808739,60.313647 58.8544597,63.8507339 54.5044074,63.8507339 C50.154355,63.8507339 46.6279408,60.313647 46.6279408,55.9504292 L46.6279408,38.9003046 Z M67.9999898,56.6239269 C68.0083216,63.4945819 62.8915959,69.2854525 56.0903028,70.1027416 L56.0903028,75.8186098 L63.4322475,75.8186098 L63.4322475,79 L45.5677322,79 L45.5677322,75.8274716 L52.9096769,75.8274716 L52.9096769,70.1027416 C46.121765,69.2870621 41.0095477,63.5165096 41,56.6593741 L41,46.4594295 L44.1717908,46.4594295 L44.1717908,56.6593741 C44.3351657,62.2603734 48.9090839,66.7158727 54.4955723,66.7158727 C60.0820607,66.7158727 64.6559789,62.2603734 64.8193538,56.6593741 L64.8193538,46.4594295 L67.9911446,46.4594295 L67.9999898,56.6239269 Z",
    id: "Shape",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.bfea0307dd668360c235e1d9ee308627.svg";
export { ForwardRef as ReactComponent };